module.exports = __webpack_public_path__ + "img/userLogo6.cd3671a1.jpg";